import { useState } from 'react';
import { useReduxState } from 'hooks';
import { CoursesViewAvailable } from 'components/courses';

import type { HomeModuleProps } from './Home';

const HomeCoursesAvailable = ({
  defaultTitle,
  limit,
  module,
  spacing
}: HomeModuleProps) => {
  const { language } = useReduxState();

  const [noData, setNoData] = useState(false);

  if (!module) return null;

  const description =
    module.descriptionTranslations?.[language] || module.description;

  const title =
    module.titleTranslations?.[language] || module.title || defaultTitle;

  return (
    <div {...(!noData ? { style: { marginTop: spacing } } : {})}>
      <CoursesViewAvailable
        description={description}
        hideIfNoData={true}
        isHomeView={true}
        limitPerPage={module.limit || limit}
        onNoData={(hasNoData) => setNoData(!hasNoData)}
        showAllLinkHref="/courses?type=available"
        title={title}
        titleShowCount={false}
      />
    </div>
  );
};

export default HomeCoursesAvailable;
